function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "develop_app");

var _ref3 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 79.37088,
  cy: 696.14536,
  rx: 79.37088,
  ry: 16.59149,
  fill: "#e6e6e6"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M342.20933,543.1347l3.10546,6.41732s17.62635,23.52346,6.73753,27.20873-16.66673-22.31063-16.66673-22.31063l-2.87885-3.63847Z",
  transform: "translate(-196.86179 -93.63157)",
  fill: "#a0616a"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M321.90524,421.62085l2.89738-1.22579s3.42881,1.22579,3.42881,6.49761S324.014,509.1331,324.014,509.1331l8.43491,42.17457-11.598,2.10873-17.92419-39.01148Z",
  transform: "translate(-196.86179 -93.63157)",
  fill: "#575a89"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M321.90524,421.62085l2.89738-1.22579s3.42881,1.22579,3.42881,6.49761S324.014,509.1331,324.014,509.1331l22.66883,36.37557-14.7611,10.54364-28.995-41.64739Z",
  transform: "translate(-196.86179 -93.63157)",
  fill: "#575a89"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M319.79651,543.92712s13.70674,5.27183,12.65237,14.76111-14.7611,198.22051-14.7611,198.22051l4.21746,21.08729-40.06585,1.05437-1.05437-136.013-28.46784,136.013H212.25133l28.46785-239.34073Z",
  transform: "translate(-196.86179 -93.63157)",
  fill: "#2f2e41"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M316.63342,773.77858l9.48928,9.48928s22.14165,4.21745,16.86983,11.598-60.09878-2.10873-60.09878-2.10873l1.05437-16.86983Z",
  transform: "translate(-196.86179 -93.63157)",
  fill: "#2f2e41"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M248.09973,773.77858l9.48928,9.48928s22.14165,4.21745,16.86983,11.598-60.09878-2.10873-60.09878-2.10873l1.05437-16.86983Z",
  transform: "translate(-196.86179 -93.63157)",
  fill: "#2f2e41"
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  cx: 89.19506,
  cy: 264.72741,
  r: 25.30475,
  fill: "#a0616a"
});

var _ref11 = /*#__PURE__*/React.createElement("polygon", {
  points: "105.011 279.489 102.902 322.717 70.216 303.739 74.434 279.489 105.011 279.489",
  fill: "#a0616a"
});

var _ref12 = /*#__PURE__*/React.createElement("polygon", {
  points: "69.162 293.195 99.739 315.337 105.011 299.521 114.5 324.826 109.228 370.164 69.162 293.195",
  fill: "#cd5c5c"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M269.30174,383.70182l30.46185,46.35394,1.22185-38.75476,3.75155,2.95687a17.388,17.388,0,0,1,6.6246,13.65623h0l14.76111,13.70674-5.27183,52.71822-1.05436,62.2075s6.32619,5.27182,4.21746,8.43492-10.54365,10.54364-20.03293,10.54364-68.53369-7.38055-68.53369-11.598,2.10873-59.04441,2.10873-59.04441V411.0772l25.30475-18.97856Z",
  transform: "translate(-196.86179 -93.63157)",
  fill: "#575a89"
});

var _ref14 = /*#__PURE__*/React.createElement("polygon", {
  points: "36.477 465.057 50.184 485.09 55.455 461.894 49.129 457.676 36.477 465.057",
  fill: "#a0616a"
});

var _ref15 = /*#__PURE__*/React.createElement("rect", {
  x: 261.4204,
  y: 615.66176,
  width: 58.52536,
  height: 2.10922,
  transform: "translate(-585.40069 582.1884) rotate(-69.73678)",
  opacity: 0.2
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M270.76856,333.58141s3.1631-15.81546,21.08729-12.65237l-2.10873,1.05436s16.86983-2.10872,14.76111,7.38056c0,0,13.70673,8.43491,10.54364,17.92419a107.284,107.284,0,0,0-4.21746,16.86983l-3.16309-3.16309s-3.16309-21.08729-22.14166-18.97856c-14.23392,1.58155-20.03292,8.30312-21.51562,13.14661a42.78187,42.78187,0,0,1-2.6049,6.62659l-1.18422.25972S253.89873,338.85324,270.76856,333.58141Z",
  transform: "translate(-196.86179 -93.63157)",
  fill: "#2f2e41"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M249.15409,410.02284l-9.5982-.44549-1.99981,1.49985a63.11876,63.11876,0,0,0-6.32618,7.38055c-2.10873,3.1631-29.52221,80.1317-29.52221,80.1317a26.86655,26.86655,0,0,0,2.10873,13.70674c3.16309,7.38055,28.46784,51.66386,28.46784,51.66386l18.97856-11.598-25.30475-51.66386,17.9242-25.30475Z",
  transform: "translate(-196.86179 -93.63157)",
  fill: "#575a89"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M810.25685,255.10731h-3.73354V152.82808a59.19645,59.19645,0,0,0-59.19662-59.19651H530.63444a59.19644,59.19644,0,0,0-59.19662,59.19651V713.93989a59.19643,59.19643,0,0,0,59.19662,59.1965H747.32669a59.19644,59.19644,0,0,0,59.19662-59.1965V327.91139h3.73354Z",
  transform: "translate(-196.86179 -93.63157)",
  fill: "#3f3d56"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M794.45513,148.86355V717.90431a44.89885,44.89885,0,0,1-44.88975,44.88986H528.4298a44.90285,44.90285,0,0,1-44.90849-44.88986V148.86355a44.90284,44.90284,0,0,1,44.90849-44.88976H555.255a21.34854,21.34854,0,0,0,19.74935,29.38992h126.077a21.34829,21.34829,0,0,0,19.74924-29.38992h28.73478A44.89884,44.89884,0,0,1,794.45513,148.86355Z",
  transform: "translate(-196.86179 -93.63157)",
  fill: "#e6e6e6"
});

var _ref20 = /*#__PURE__*/React.createElement("rect", {
  x: 330.57962,
  y: 351.56498,
  width: 223.09362,
  height: 223.09362,
  fill: "#fff"
});

var _ref21 = /*#__PURE__*/React.createElement("rect", {
  x: 379.83806,
  y: 250.97436,
  width: 125.83839,
  height: 9.45829,
  fill: "#fff"
});

var _ref22 = /*#__PURE__*/React.createElement("rect", {
  x: 363.00089,
  y: 275.55118,
  width: 158.36805,
  height: 9.45829,
  fill: "#fff"
});

var _ref23 = /*#__PURE__*/React.createElement("rect", {
  x: 394.86545,
  y: 373.10177,
  width: 86.84205,
  height: 6.52724,
  fill: "#e6e6e6"
});

var _ref24 = /*#__PURE__*/React.createElement("rect", {
  x: 394.86545,
  y: 392.26358,
  width: 134.10303,
  height: 6.52724,
  fill: "#cd5c5c"
});

var _ref25 = /*#__PURE__*/React.createElement("rect", {
  x: 396.25979,
  y: 410.51267,
  width: 109.29102,
  height: 6.52724,
  fill: "#e6e6e6"
});

var _ref26 = /*#__PURE__*/React.createElement("rect", {
  x: 394.86545,
  y: 430.5361,
  width: 63.80232,
  height: 6.52724,
  fill: "#e6e6e6"
});

var _ref27 = /*#__PURE__*/React.createElement("rect", {
  x: 394.86545,
  y: 450.09475,
  width: 96.29425,
  height: 6.52724,
  fill: "#cd5c5c"
});

var _ref28 = /*#__PURE__*/React.createElement("rect", {
  x: 355.28438,
  y: 371.04853,
  width: 10.63372,
  height: 10.63372,
  fill: "#e6e6e6"
});

var _ref29 = /*#__PURE__*/React.createElement("rect", {
  x: 355.28438,
  y: 390.21034,
  width: 10.63372,
  height: 10.63372,
  fill: "#cd5c5c"
});

var _ref30 = /*#__PURE__*/React.createElement("rect", {
  x: 355.28438,
  y: 408.45943,
  width: 10.63372,
  height: 10.63372,
  fill: "#e6e6e6"
});

var _ref31 = /*#__PURE__*/React.createElement("rect", {
  x: 355.28438,
  y: 428.48286,
  width: 10.63372,
  height: 10.63372,
  fill: "#e6e6e6"
});

var _ref32 = /*#__PURE__*/React.createElement("rect", {
  x: 355.28438,
  y: 448.04151,
  width: 10.63372,
  height: 10.63372,
  fill: "#cd5c5c"
});

var _ref33 = /*#__PURE__*/React.createElement("rect", {
  x: 394.86545,
  y: 469.77567,
  width: 86.84205,
  height: 6.52724,
  fill: "#e6e6e6"
});

var _ref34 = /*#__PURE__*/React.createElement("rect", {
  x: 394.86545,
  y: 488.93748,
  width: 134.10303,
  height: 6.52724,
  fill: "#cd5c5c"
});

var _ref35 = /*#__PURE__*/React.createElement("rect", {
  x: 396.25979,
  y: 507.18657,
  width: 109.29102,
  height: 6.52724,
  fill: "#e6e6e6"
});

var _ref36 = /*#__PURE__*/React.createElement("rect", {
  x: 394.86545,
  y: 527.21,
  width: 63.80232,
  height: 6.52724,
  fill: "#e6e6e6"
});

var _ref37 = /*#__PURE__*/React.createElement("rect", {
  x: 394.86545,
  y: 546.76865,
  width: 96.29425,
  height: 6.52724,
  fill: "#e6e6e6"
});

var _ref38 = /*#__PURE__*/React.createElement("rect", {
  x: 355.28438,
  y: 467.72243,
  width: 10.63372,
  height: 10.63372,
  fill: "#e6e6e6"
});

var _ref39 = /*#__PURE__*/React.createElement("rect", {
  x: 355.28438,
  y: 486.88424,
  width: 10.63372,
  height: 10.63372,
  fill: "#cd5c5c"
});

var _ref40 = /*#__PURE__*/React.createElement("rect", {
  x: 355.28438,
  y: 505.13333,
  width: 10.63372,
  height: 10.63372,
  fill: "#e6e6e6"
});

var _ref41 = /*#__PURE__*/React.createElement("rect", {
  x: 355.28438,
  y: 525.15676,
  width: 10.63372,
  height: 10.63372,
  fill: "#e6e6e6"
});

var _ref42 = /*#__PURE__*/React.createElement("rect", {
  x: 355.28438,
  y: 544.71541,
  width: 10.63372,
  height: 10.63372,
  fill: "#e6e6e6"
});

var _ref43 = /*#__PURE__*/React.createElement("circle", {
  cx: 442.12643,
  cy: 149.7949,
  r: 72.73561,
  fill: "#fff"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M638.38756,207.75646a35.856,35.856,0,1,0,35.856,35.856A35.96137,35.96137,0,0,0,638.38756,207.75646Zm0,10.75678A10.75679,10.75679,0,1,1,627.63077,229.27a10.79288,10.79288,0,0,1,10.75679-10.75679Zm0,51.78428a26.12081,26.12081,0,0,1-21.51358-11.4808c.17239-7.17119,14.34239-11.1188,21.51358-11.1188s21.34119,3.94761,21.51357,11.1188a26.16432,26.16432,0,0,1-21.51357,11.4808Z",
  transform: "translate(-196.86179 -93.63157)",
  fill: "#cd5c5c"
});

var _ref45 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 725.3333,
  cy: 687.14536,
  rx: 80.94312,
  ry: 16.59149,
  fill: "#e6e6e6"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M836.40566,534.70823,825.775,532.86432s-21.72627-10.02589-23.04335-2.43258S822.149,544.75021,822.149,544.75021l22.31494-2.38683Z",
  transform: "translate(-196.86179 -93.63157)",
  fill: "#ffb8b8"
});

var _ref47 = /*#__PURE__*/React.createElement("polygon", {
  points: "701.374 364.197 686.483 432.01 636.77 439.031 634.864 459.037 698.973 459.207 731.035 400.629 701.374 364.197",
  fill: "#575a89"
});

var _ref48 = /*#__PURE__*/React.createElement("polygon", {
  points: "701.374 364.197 686.483 432.01 636.77 439.031 634.864 459.037 698.973 459.207 731.035 400.629 701.374 364.197",
  opacity: 0.2
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M822.56467,477.4952l-7.5862-7.672s-11.8721-20.775-17.35213-15.35634,7.50035,22.93027,7.50035,22.93027l19.5564,11.00911Z",
  transform: "translate(-196.86179 -93.63157)",
  fill: "#ffb8b8"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M927.07534,436.38614l9.33951-2.27659a24.04415,24.04415,0,0,0,23.59809-28.80606v0a31.42762,31.42762,0,0,0-31.38812-31.46707h-.00006a31.42762,31.42762,0,0,0-31.46707,31.38812v0A24.97449,24.97449,0,0,0,927.07534,436.38614Z",
  transform: "translate(-196.86179 -93.63157)",
  fill: "#2f2e41"
});

var _ref51 = /*#__PURE__*/React.createElement("polygon", {
  points: "675.283 498.398 682.885 581.64 696.654 663.348 719.774 663.377 716.792 583.224 704.584 486.104 675.283 498.398",
  fill: "#2f2e41"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "M896.60452,752.35942l-15.425,9.22866s-24.66527,3.0517-20.05093,10.7642,58.56694,3.15624,58.57081.07356-1.51617-20.03932-4.59884-20.04319Z",
  transform: "translate(-196.86179 -93.63157)",
  fill: "#2f2e41"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M940.39116,584.8379s-.43366,11.90067-11.24626,30.38317l1.46971,57.03141,55.39908,70.97121L965.955,760.15323l-67.722-77.15205-16.83855-92.50153L903.00025,568.948Z",
  transform: "translate(-196.86179 -93.63157)",
  fill: "#2f2e41"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "M981.38968,743.21788s18.49218,3.1059,15.39982,10.80872-10.84357,43.14389-30.87514,38.49471c0,0-9.248-.01162-6.15761-6.17309a111.49587,111.49587,0,0,1,6.1789-10.78162l.02517-20.03738Z",
  transform: "translate(-196.86179 -93.63157)",
  fill: "#2f2e41"
});

var _ref55 = /*#__PURE__*/React.createElement("circle", {
  cx: 720.2041,
  cy: 321.20017,
  r: 23.12008,
  fill: "#ffb8b8"
});

var _ref56 = /*#__PURE__*/React.createElement("polygon", {
  points: "730.974 336.627 730.941 362.83 706.28 362.799 709.395 336.6 730.974 336.627",
  fill: "#ffb8b8"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  d: "M943.03811,595.19874l-15.2998-2.56a141.80249,141.80249,0,0,0-58.68018,2.47l6.92017-68.89.8999-8.98,1.92993-19.23s-6.66992-25.34,3.12012-33.9c11.94995-10.45,22.53-18.77,22.53-18.77l23.35986,1.87c13.06006,26.04,10.23,58.77,1.42017,94.03Z",
  transform: "translate(-196.86179 -93.63157)",
  fill: "#575a89"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  d: "M917.537,450.78183,866.04924,497.3582l-44.55605-23.13876-9.355,11.44933,39.3576,34.67809a18.5009,18.5009,0,0,0,18.8379,1.61649l50.20921-24.29856Z",
  transform: "translate(-196.86179 -93.63157)",
  fill: "#575a89"
});

var _ref59 = /*#__PURE__*/React.createElement("circle", {
  cx: 764.83389,
  cy: 289.24994,
  r: 14.91667,
  fill: "#2f2e41"
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  d: "M947.93235,374.86271A14.9097,14.9097,0,0,1,965.78444,360.258a14.90972,14.90972,0,1,0-9.29933,28.09954A14.9044,14.9044,0,0,1,947.93235,374.86271Z",
  transform: "translate(-196.86179 -93.63157)",
  fill: "#2f2e41"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  d: "M935.13551,383.3225l-20.10987-3.70277-15.46537,9.693a23.45973,23.45973,0,0,0-10.80675,22.89456l15.48916-3.926,3.46839-8.69693h0a25.3707,25.3707,0,0,0,9.04062,8.77665c8.77591,5.03766,10.81045,15.74616,11.84807,27.29329l16.96635-9.22671,10.81065-16.94116Z",
  transform: "translate(-196.86179 -93.63157)",
  fill: "#2f2e41"
});

var _ref62 = /*#__PURE__*/React.createElement("polygon", {
  points: "719.276 390.037 679.117 432.587 680.016 423.607 719.276 390.037",
  opacity: 0.2
});

var SvgTheersvg = function SvgTheersvg(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a33e59cf-d648-43ac-a922-97b4db9e4e4a",
    "data-name": "Layer 1",
    width: 806.27642,
    height: 712.73685,
    viewBox: "0 0 806.27642 712.73685",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTheersvg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/theer.svg.8436a3cf.svg";
export { ForwardRef as ReactComponent };